import './AboutUs.css'


const AboutUs = ()=>{

  

  return( <>
  
  <section id='rreth-nesh' className="about-us">
    <div className="content">
      

      <h2>KUSH JEMI NE</h2>
      <p>Në ROI Kids, ne jemi të përkushtuar për të pasuruar me njohuri teknologjike krijuesit dhe inovatorët e së nesërmes. 
        Misioni ynë është të fuqizojmë fëmijët me aftësitë dhe njohuritë që u nevojiten për të pasur sukses në epokën digjitale.</p>
      <p>Programet tona, të krijuara posaçërisht për mendjet e reja, përfshijnë fushat emocionuese të dizajnit grafik, marketingut digjital,
         programimit, zhvillimit të lojërave, si dhe editimit të videove.</p>
      <p>Nëpërmjet përvojave praktike dhe interaktive të të mësuarit, ne ndezim pasionin e tyre për teknologjinë dhe kreativitetin,
         si dhe i orientojmë ata përmes një udhëtimi drejt zbulimit dhe zhvillimit të aftësive dhe pasioneve.</p>
      <p>Në ROI Kids, fëmijët nuk njohin vetëm teknologjinë, ata do të jenë krijuesit e saj. Ne u japim atyre mjetet,
         udhëzimet dhe mjedisin që i stimulon ata të kthejnë idetë e tyre krijuese në projekte reale. </p>
      <p>Programet tona nuk janë vetëm edukative, por edhe frymëzuese, duke nxitur kuriozitetin, kreativitetin,
         zgjidhjen e problemeve dhe bashkëpunimin.</p>
      <p>Bashkohuni me ne në ROI Kids - Le ta krijojmë bashkë të ardhmen e teknologjisë!</p>



    </div>
  </section>



    
  
  
  
  
  
  
  </>
  )
}

export default AboutUs;